import { useFormik } from 'formik';
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { aboutLifePartnerEditSchema } from '../../../ValidationSchema';
import { editAboutLifePartner } from '../../../../asiosConfig';
import Popup from '../../../Popup';
import { Button, Card, CardContent, CardHeader, TextField } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';

export const AboutPartnerEdit = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const userProfile = location.state?.userProfileData || {};
    const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

    const handleClosePopup = () => {
        setPopupData({ ...popupData, open: false });
    };
    const formik = useFormik({
        initialValues: {
            aboutLifePartner: userProfile.aboutLifePartner || '',
            // tokan: tokan
        },
        validationSchema: aboutLifePartnerEditSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                const response = await editAboutLifePartner(values);
                if (response.status === 200 || response.status === 201) {
                    setPopupData({ open: true, type: 'success', message: 'About Partner updated successfully' });
                    setTimeout(() => {
                        navigate(-1);
                    }, 2000);
                }

            } catch (error) {
                setPopupData({ open: true, type: 'error', message: error.response?.data?.message || "An error occurred" });
            } finally {
                setSubmitting(false);
            }
        },
    });
    return (
        <div className="col-lg-9 col-12">
            <Card className="editProfileBlock">
                <CardHeader
                    avatar={<ArrowBack sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
                    title="About Partner"
                    subheader=""
                    titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
                />
                <CardContent>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <TextField
                                fullWidth
                                label="What I Am Looking For"
                                variant="outlined"
                                className="mb-3"
                                name="aboutLifePartner"
                                value={formik.values.aboutLifePartner}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.aboutLifePartner && Boolean(formik.errors.aboutLifePartner)}
                                helperText={formik.touched.aboutLifePartner && formik.errors.aboutLifePartner}
                                multiline
                                rows={4}
                            />
                        </div>
                        {/* <div className="d-grid col-4 mx-auto mt-2"> */}
                        <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
                            {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
                        </Button>
                        {/* </div> */}

                    </form>
                </CardContent>
            </Card>

            <Popup
                open={popupData.open}
                type={popupData.type}
                message={popupData.message}
                onClose={handleClosePopup}
            />
        </div >
    )
}
